import styled from 'styled-components';
import { Modal as AntModal } from 'antd';

export const StyledBaseModal = styled(AntModal)`
  .ant-modal-content,
  .ant-modal-header {
    background-color: white;
  }

  .ant-modal-header {
    border-bottom: 0px;
  }

  .ant-modal-content {
    border-radius: 16px;
  }
`;
